import { render, staticRenderFns } from "./ordinaryData.vue?vue&type=template&id=25984400"
import script from "./ordinaryData.vue?vue&type=script&lang=js"
export * from "./ordinaryData.vue?vue&type=script&lang=js"
import style0 from "./ordinaryData.vue?vue&type=style&index=0&id=25984400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports